module.exports = __webpack_public_path__ + "img/7.9a5677f9.jpg";